// extracted by mini-css-extract-plugin
export default {"youtubeDialog":"youtube-dialog_youtubeDialog__E3uD-","header":"youtube-dialog_header__w39oa","text":"youtube-dialog_text__hkksc","content":"youtube-dialog_content__DBOwB"};